import React, { Component } from 'react';

import { hot } from 'react-hot-loader/root';

import Install from 'common/auth/Install';
import LazyLoadedImage from 'common/LazyLoadedImage';

import CannyClickupIntegration from 'img/canny-clickup-integration.png';

import 'css/components/clickup/_ClickupInstall.scss';

class ClickupInstall extends Component {
  render() {
    const path = `/admin/settings/clickup`;
    return (
      <div className="clickupInstall">
        <LazyLoadedImage alt="Canny Clickup integration" src={CannyClickupIntegration} />
        <div className="heading">Integrate Canny with ClickUp</div>
        <Install path={path} />
      </div>
    );
  }
}

export default hot(ClickupInstall);
